import axios from "axios";
import { URL } from "pages/menu";

/**
 * post 전송
 * @param {string} url 전송 URL
 * @param {object} body 전송 데이터
 * @param {boolean} isShowLoading 로딩중 표시 여부. default true.
 * @param {boolean} isFailAlert fail 또는 error시에 alert표시 여부. default true.
 */
export async function sendPost(url, body, isShowLoading, isFailAlert) {
	return await sendReq(url, "post", null, body, null, isShowLoading, isFailAlert);
}

/**
 * put 전송
 * @param {string} url 전송 URL
 * @param {object} body 전송 데이터
 * @param {boolean} isShowLoading 로딩중 표시 여부. default true.
 * @param {boolean} isFailAlert fail 또는 error시에 alert표시 여부. default true.
 */
export async function sendPut(url, body, isShowLoading, isFailAlert) {
	return await sendReq(url, "put", null, body, null, isShowLoading, isFailAlert);
}

/**
 * delete 전송
 * @param {string} url 전송 URL
 * @param {object} body 전송 데이터
 * @param {boolean} isShowLoading 로딩중 표시 여부. default true.
 * @param {boolean} isFailAlert fail 또는 error시에 alert표시 여부. default true.
 */
export async function sendDelete(url, body, isShowLoading, isFailAlert) {
	return await sendReq(url, "delete", null, body, null, isShowLoading, isFailAlert);
}

/**
 * get 전송
 * @param {string} url 전송 URL
 * @param {object} param 전송 데이터
 * @param {boolean} isShowLoading 로딩중 표시 여부. default true.
 * @param {boolean} isFailAlert fail 또는 error시에 alert표시 여부. default true.
 */
export async function sendGet(url, param, isShowLoading, isFailAlert) {
	let result =  await sendReq(url, "get", param, null, null, isShowLoading, isFailAlert);
	return result;
}

/**
 * File 전송
 * @param {string} url 전송 URL
 * @param {files} files 목록
 * @param {string} usageCd 사용처 코드 (공통코드 FILE_USAGE_CD)
 * @param {boolean} isShowLoading 로딩중 표시 여부. default true.
 * @param {boolean} isFailAlert fail 또는 error시에 alert표시 여부. default true.
 */
export async function sendPostFile(url, files, usageCd, isShowLoading, isFailAlert) {
	const body = new FormData();
	files.forEach(file => {
		body.append("files", file);
	});
	body.append("fileUsageCd", usageCd)
	return await sendReq(url, "post", null, body, false, isShowLoading, isFailAlert);
}

async function sendReq(url, type, param, body, contentType, isShowLoading, isFailAlert) {
	isShowLoading = isShowLoading == null ? true : isShowLoading;
	isFailAlert = isFailAlert == null ? true : isFailAlert;
	if (typeof contentType != "boolean") {
		contentType = contentType == null || contentType === "" ? "application/json; charset=utf8" : contentType;
	}
	let reqData = (type === "post" || type === "delete" || type === "put" ? body : param);

	if(isShowLoading) {
		showLoading();	// 로딩중 표시
	}

	const headers = {
        Authorization: localStorage.accessToken,
        "Content-Type": contentType,
    };

	let response = null;
	try {
		if(type === "post") {
			response = await axios.post(url, reqData, {headers});
		} else if(type === "put") {
			response = await axios.put(url, reqData, {headers});
		} else if(type === "delete") {
			response = await axios.delete(url, {headers: headers, data: reqData});
		} else if(type === "get") {
			
			if(reqData) {
				let params = "";
				const keys = Object.keys(reqData);
				for(let i = 0; i<keys.length; i++) {
					const key = keys[i];
					if(params !== "") params += "&"
					params += key + "=" + reqData[key];
				}
				if(url.indexOf("?") === -1) {
					url += "?";
				} else {
					url += "&";
				}
				url += encodeURI(params);
			}
			response = await axios.get(url, {headers});
		}
	} catch(e) {
		// 서버가 죽어있는 등 Backend Application에 정상적으로 도달하지 못한 경우.
		alert("서버가 응답하지 않습니다.");
		hideLoadingForce();
		return {respCode: "ERROR", data: {}};
	}

	if(response.data.respCode === "SUCCESS") {	// 성공
		hideLoading();	// 로딩중 숨기기
		return response.data;
	} else if (response.data.respCode === "NO_ACCESS_TOKEN") {	// 토큰 없음
		if(isFailAlert) {
			// alert("로그인이 만료 되었습니다.");
			loginExpiredAlert();
		}
		hideLoading();	// 로딩중 숨기기
		return "login_req";
	} else if (response.data.respCode === "EXPIRED_ACCESS_TOKEN") {	// 토큰 만료
		let refreshResult = await tokenRefresh()	// 토큰 갱신
		if(refreshResult) {// 갱신 성공 시 원래 요청 다시 호출
			let orgReqResult = sendReq(url, type, param, body, contentType, isShowLoading, isFailAlert)
			return orgReqResult;
		} else {
			setTokenToStorage("", "");	// 토큰 제거
			if(isFailAlert) {
				// alert("로그인이 만료 되었습니다.");
				loginExpiredAlert();
			}
			hideLoading();	// 로딩중 숨기기
			return "login_req";
		}
	} else {
		// 그외 오류
		hideLoading();	// 로딩중 숨기기
		if(isFailAlert) {
			alert(response.data.respMsg);
		}
		// return new Error(response.data);
		return response.data;
	}
}
// 로그인 Alert이 1번만 실행되도록 S
// 로그인 Alert Function
let loginAlert = () => alert("로그인이 만료 되었습니다.");
// index.jsx에서 페이지 이동시 다시 function을 설정. 이렇게 안하면 처음에 1번만 alert이 뜨고 다시 로그인 하고 다시 만료되면 alert이 안뜸
export const setLoginAlert = () => {
	loginAlert = () => alert("로그인이 만료 되었습니다.");
}
// 로그인 만료 alert이 1번만 뜨도록 1번 실행하고 null로 변경.
// 이 파일 안에서 변수 처리 해서 1번만 실행하도록 해봤는데 잘 안됨.
const loginExpiredAlert = () => {
	if((typeof loginAlert).toLowerCase() === "function") loginAlert.apply();
	loginAlert = null;
	if(window.opener) {
		// 팝업일때는 부모창 로그인 이동 및 창닫기
		window.opener.goToLogin();
		window.close();
	} else {
		// 팝업이 아닐때 로그인 페이지 이동.
		document.location.href = URL.LOGIN;
	}
}
// 로그인 Alert이 1번만 실행되도록 E

// 토큰을 localStorage에 설정.
export async function setTokenToStorage(accessToken, refreshToken) {
	localStorage.setItem("accessToken", accessToken);
	localStorage.setItem("refreshToken", refreshToken);
}

async function tokenRefresh() {
	const url = "/api/token-refresh";
	const param = {refreshToken: localStorage.getItem("refreshToken")}
	let result = await sendGet(url, param, false, false);
	if(result.respCode === "SUCCESS") {
		await setTokenToStorage(result.data.accessToken, result.data.refreshToken);
		return true;
	} else {
		return false;
	}

}



function showLoading() {
	if(document.getElementById("div_loading") === null) return;

	const cnt = document.getElementById("div_loading").getAttribute("data-cnt") * 1;

	document.getElementById("div_loading").setAttribute("data-cnt", cnt+1);
	document.getElementById("div_loading").style.display = "flex";
}
function hideLoading() {
	if(document.getElementById("div_loading") === null) return;

	let cnt = document.getElementById("div_loading").getAttribute("data-cnt") * 1 - 1;
	if(cnt < 0) cnt = 0;
	
	document.getElementById("div_loading").setAttribute("data-cnt", cnt);
	if(cnt === 0) {
		document.getElementById("div_loading").style.display = "none";
	}
}
function hideLoadingForce() {
	if(document.getElementById("div_loading") === null) return;
	
	document.getElementById("div_loading").setAttribute("data-cnt", 0);
	document.getElementById("div_loading").style.display = "none"
}

export async function checkLogin(isFailAlert) {
	let result = await sendGet("/api/check-login", null, true, isFailAlert);
	return result;
}
